import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import styled from 'styled-components';
import { isBtoCFlow } from '__utils/common-utils';
import { COLOR } from 'constants/colors';
import { useMediaQuery } from 'react-responsive';
import { FormErrorMessageSpan, InputMintDiv, WhiteCardWrapper, CommonTitleDiv } from 'views/common-styled-components';
import { SuccessButton } from 'components/button';
import { useForm } from 'react-hook-form';
import OnboardingProgressSteps from 'components/onboarding-progress-steps';
import '../../../font-icon.css';
import uploadImage from 'images/upload.png';
import camera from 'images/camera.png';
import update from 'images/update.png';
import { ProfileProgressStepsList } from 'constants/progress-steps-constants';
import { ENDPOINTS } from 'constants/endpoints';
import useFlashToggler from 'hooks/use-flash-toggler';
import * as profileviewActions from '../profile-view.actions';
import { getEncryptedUserId } from '__utils/common-utils';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import resolveURLParams from '__utils/url-params-resolver';
import ProfileViewSelector from '../profile-view.selector';
import { getDefaultHeaders, post, fetchPost } from '__utils/ajax-wrapper';
import { propsToJS } from '__utils/immutable-to-js';
import { useDispatch, useSelector } from 'react-redux';
import CartSummary from 'components/cart-summary/index';
import { CommonStyledComponentProps } from '__utils/type';
import Checkbox from '__utils/customisedCheckBox';
import { useDeepCompare } from 'hooks/use-deep-memo';
import FatcaDetails from './fatcaDetails';
import { compareBusinessTypes, compareOtherTypes, compareServiceTypes } from '__utils/helpers';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { getAgentCode, getUserDetails, setUserDetails } from '__utils/storage';
import RiskProfileViewSelector from '../risk-profile/risk-profile.selector';
import { Row, Col } from 'antd';
import { LayoutContext } from 'components/app-routes';
import NomineeFieldArray from './nominee-list';
import CustomRadio from 'components/custom-radio';
import LoginSelector from 'views/login/login.selector';
import OtpPopup from './otp-popup';


const OccupationDetailsWhiteCard = styled.div<CommonStyledComponentProps>`
    .inner-cont {
        padding: 16px 0px;   
    }
    h3 {
        font-weight: 600;
        font-size: 18px;
    } 
    select {
        border-radius: 2px;
        border: solid 1px ${COLOR.LIGHTGREY};
        background-color: ${COLOR.WHITE};
        padding: 10px;
        margin: 4px 0 16px 0;
        height: 40px;
        vertical-align: middle;
        width: 100%;
    }
    .form-group .form-check{
        width:10px;
        height: 10px;
    }
    input[type="checkbox"] {
       height: 20px !important;
       width: 20px;
      }
    #signatureFile,#captureSignatureImg  {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }
    .floatUpdateDiv{
        display: flex;
        gap:1%;
    }
    .updatePic{
        color: #00a465;
        cursor: pointer;
        margin-top: ${(props: any) => props.isMobile ? "10px" : "180px"};
    }
    .labelForFileInput{
        background-color: white;
        height: 80px;
        width: 120px;
        border: solid 1px #00a465;
        border-radius: 5px;
        text-align:center;
        align-items: center;  
        cursor: pointer;
        vertical-align: middle !important;
        padding:15px;
      
    }
    .greenText{
        color: #00A465;
        font-weight: 500
    }
    .occupationTypeWidth{
        width: ${(props: any) => !props.isMobile ? "500px" : ""};
        display: flex;
    }
    select:invalid{
        color: gray;
    }
    option{
        color: black;
    }
    
`;

const OccupationDetailsSubmitButton = styled(SuccessButton) <CommonStyledComponentProps>`
    width: 172px;
    font-size: 14px; 
    margin-top: 1rem;
`;
const OccupationForm = styled.div <CommonStyledComponentProps>`
    width: ${(props: any) => props.isMobile ? '100%' : '71%'};  
`;

const SuccessBtn = styled(SuccessButton) <CommonStyledComponentProps>`
  width: 150px;
  font-size: 14px; 
`;

const OccupationDetails: React.FC = () => {
    const history = useHistory();
    const flash = useFlashToggler();
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    // eslint-disable-next-line
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);
    const [signatureUploaded, setSignatureUploaded] = useState(false);
    const [signaturePicUrl, setSignaturePicUrl] = useState<any>("");
    const { profileView } = propsToJS(useSelector(ProfileViewSelector));
    const { riskProfileResult } = propsToJS(useSelector(RiskProfileViewSelector));
    const [fatcaCheckedStatus, setFatcaCheckedStatus] = useState<boolean>(profileView ? profileView.fatcaCompliant : false);
    const [signatureURLError, setSignatureURLError] = useState<boolean>(false);
    const [showFatcaDetails, setShowFatcaDetails] = useState<boolean>(false);
    const [noFatcaError, setNoFatcaError] = useState<boolean>(false);
    const [occupationTypes, setOccupationTypes] = useState<any>("");
    const [defaultOccupationValues, setDefaultOccupationValues] = useState<any>();
    const [otpScreen, setOtpScren] = useState(false);
    const { currentUserDetails } = propsToJS(useSelector(LoginSelector));
    const incomeSlabs: any = [
        { value: ['Below 1 Lakh', 'Below 1 Lac'], name: 'Below 1 Lakh' },
        { value: ['>1 <=5 Lacs', '1-5 Lacs'], name: 'Between 1 and 5 lakhs' },
        { value: ['>5 <=10 Lacs', '5-10 Lacs'], name: '5 to 10 lakhs' },
        { value: ['>10 <= 25 Lacs', '10-25 Lacs'], name: '10 to 25 lakhs' },
        { value: ['25 Lacs < = 1 Crore', '25 Lacs-1 crore'], name: '25 lakhs to 1 cr' },
        { value: ['Above 1 Crore', '>1 crore'], name: 'Above 1 cr' }
    ]
    const defaultValues = {
        nomineeList: [
            {
                nomineeName: '',
                relationship: '',
                nomineePercentage: '',
                isNomineeMinor: 'false',
                nomineeDOB: '',
                guardianName: ''
            }
        ],
        occupation: compareServiceTypes(occupationTypes),
        incomeSlab: defaultOccupationValues?.incomeSlab,
        aadhar: defaultOccupationValues?.aadhar
    };

    const formState = useForm({ defaultValues, mode: 'onChange' });
    const { register, handleSubmit, errors } = formState;

    useEffect(() => {
        SetLayoutProps({
            config: { title: 'Investor Profile' }
        })
        dispatch(profileviewActions.fetchGetProfileView(getEncryptedUserId()));
        Mixpanel.track(getEventName("occupationAndNomineeDetails", "loaded", "checkout"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isBtoCFlow: isBtoCFlow(),
        })
    }, []);

    const handleFatca = (active: boolean, fatcaCompliant?: boolean) => {
        setShowFatcaDetails(active);
        if (fatcaCompliant !== undefined) {
            setNoFatcaError(active);
            setDefaultOccupationValues({ ...defaultOccupationValues, fatcaCompliant: fatcaCompliant })
            setFatcaCheckedStatus(fatcaCompliant);
        }
    }

    const otpSuccess = () => {
        setOtpScren(false);
    }


    useEffect(() => {
        if (profileView) {
            profileView && setDefaultOccupationValues(profileView);
            (profileView?.optIn === undefined) && optInOutHandler(true);
            if (profileView?.signatureURL) {
                setSignatureUploaded(true);
                setSignaturePicUrl(profileView?.signatureURL);
            }
            profileView?.getErrorStatus && flash.error(profileView?.getErrorStatus);
            setFatcaCheckedStatus(profileView?.fatcaCompliant);
            profileView?.occupation && setOccupationTypes(profileView.occupation);
        }
    }, [useDeepCompare(profileView)]);

    useEffect(() => {
        if (currentUserDetails) {
            setUserDetails(currentUserDetails);
        }
    }, [useDeepCompare(currentUserDetails)]);

    const onChangePicture = async (e: any) => {

        setSignatureURLError(false);
        if (e && e.size > 5000000) {
            flash.error("Invalid file. You can upload image file of < 5mb size.");
        }
        else if (e) {
            Mixpanel.track(getEventName("signatureImageUpload", "clicked", "checkout"), {
                agentCode: getAgentCode(),
                user: getUserDetails(),
                isBtoCFlow: isBtoCFlow(),
            });
            const formData = new FormData();
            formData.append('file', e);
            fetchPost(
                ENDPOINTS.UPLOAD_SIGNATURE_PIC, formData, null, true
            ).then((response: any) => {
                if (response.value) {
                    setSignatureUploaded(true);
                    setSignaturePicUrl(response.value);
                    flash.success("File uploaded successfully");
                }
                else {
                    flash.error("Can not upload file now. Please try later.");

                }
            }).catch((error: any) => {
                flash.error("Can not upload file now. Please try later.");
            })
        }

    }

    const onSubmitOccupationDetails = (data: any) => {
        !fatcaCheckedStatus && setNoFatcaError(true);
        !signaturePicUrl && setSignatureURLError(true);
        if (signaturePicUrl && fatcaCheckedStatus) {
            submitNProccedtoNext(data, {
                ...profileView, ...{
                    occupationType: data?.occupation,
                    incomeSlab: data?.incomeSlab,
                    aadhar: data?.aadhar,
                    nomineeList: defaultOccupationValues?.optIn ? data?.nomineeList : [],
                    signatureURL: signaturePicUrl,
                    fatcaCompliant: fatcaCheckedStatus,
                    optIn: defaultOccupationValues?.optIn,
                    baseUrl: window.location.origin
                }
            });
        }


    };
    const submitNProccedtoNext = (data:any, profileData: any) => {
        if(profileView?.registeredWithBse === 3){
            history.push(`/profile/mandates/setup-mandate?flowType=checkout&ucc=${getEncryptedUserId()}`);
        }
        else{
            profileData && post(resolveURLParams(ENDPOINTS.POST_SAVE_PROFILE_DETAILS, {}, { ucc: getEncryptedUserId() }), profileData, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                if (response?.response?.meta?.message === "success") {
                    setOtpScren(true);
                    Mixpanel.track(getEventName("occupationAndNomineeInfo", "completed", "checkout"), {
                    agentCode: getAgentCode(),
                    user: getUserDetails(),
                    isBtoCFlow: isBtoCFlow(),
                    });
                } else if (response?.response?.meta?.message === "failure") {
                    flash.error(response?.response?.meta?.error);
                    // dispatch(profileviewActions.updateProfileViewError(response?.response?.meta?.error));
                }
            }, (error: AjaxError) => {
                flash.error("Something went wrong. Please try again later.")
            });
        }
        
    }

    const optInOutHandler = (value: boolean) => {
        setDefaultOccupationValues({ ...defaultOccupationValues, optIn: value })
    }


    return (<div>
        <WhiteCardWrapper isMobile={isMobile} fullWidth>
            <OccupationDetailsWhiteCard isMobile={isMobile}>
                {!isMobile && <CartSummary />}
                {!isMobile && <CommonTitleDiv>Investor Profile</CommonTitleDiv>}

                <OccupationForm isMobile={isMobile}>
                    <OnboardingProgressSteps
                        stepsList={ProfileProgressStepsList}
                        currentStep={3}
                    />
                    <form key={1} name="occupationDetailsForm" onSubmit={handleSubmit(onSubmitOccupationDetails)}>
                        <p style={{ fontSize: "14px", margin: '7px 0', }}>Occupation Type</p>
                        <div className="occupationTypeWidth">
                            <div className="flex-row mb-20">
                                <CustomRadio
                                    name="occupation"
                                    label="Service"
                                    value="S"
                                    checked={compareServiceTypes(occupationTypes)}
                                    onChange={e => setOccupationTypes(e.currentTarget.value)}
                                    radiobuttonRef={register({
                                        required: "Please enter your occupation type.",
                                    })}
                                    disabled={profileView?.registeredWithBse === 3}

                                />
                                <CustomRadio
                                    name="occupation"
                                    label="Business"
                                    value="B"
                                    checked={compareBusinessTypes(occupationTypes)}
                                    onChange={e => setOccupationTypes(e.currentTarget.value)}
                                    radiobuttonRef={register({
                                        required: "Please enter your occupation type.",
                                    })}
                                    disabled={profileView?.registeredWithBse === 3}

                                />
                                <CustomRadio
                                    name="occupation"
                                    label="Others"
                                    value="O"
                                    checked={compareOtherTypes(occupationTypes)}
                                    onChange={e => setOccupationTypes(e.currentTarget.value)}
                                    radiobuttonRef={register({
                                        required: "Please enter your occupation type.",
                                    })}
                                    disabled={profileView?.registeredWithBse === 3}

                                />
                            </div>
                        </div>
                        {(errors?.occupation) ? <FormErrorMessageSpan style={{ marginBottom: "15px" }}>{errors.occupation.message}</FormErrorMessageSpan> : null}
                        <Row gutter={24}>
                            <Col xs={24} md={10}>
                                <div className="form-group">
                                    <label htmlFor="incomeSlab">Income Slab</label>
                                    <br />
                                    <select
                                        name="incomeSlab"
                                        defaultValue={defaultOccupationValues?.incomeSlab ?? ""}
                                        disabled={profileView?.registeredWithBse === 3}
                                        ref={register({
                                            required: "Please select your income slab",
                                        })}
                                    >
                                        <option value="" disabled>Select your income slab</option>
                                        {incomeSlabs.map((element: any) => (
                                            <option value={element.value[0]} selected={element?.value?.includes(defaultOccupationValues?.incomeSlab)} >{element?.name}</option>))
                                        }
                                    </select>
                                    {(errors?.incomeSlab) ? <FormErrorMessageSpan>{errors.incomeSlab.message}</FormErrorMessageSpan> : null}
                                </div>
                            </Col>
                            <Col xs={24} md={10}>

                                <InputMintDiv>
                                    <label htmlFor="aadhar">Adhaar Number</label>
                                    <br />
                                    <input
                                        name='aadhar'
                                        type="text"
                                        defaultValue={defaultOccupationValues?.aadhar ?? ""}
                                        disabled={profileView?.registeredWithBse === 3}
                                        placeholder="Enter adhaar no."
                                        ref={register({
                                            required: "Please enter your adhaar number",
                                            pattern: {
                                                value: /^[ 0-9 ]{4}[ - ]?[ 0-9 ]{4}[ - ]?[ 0-9 ]{4}$/,
                                                message: "Please enter valid adhaar no."
                                            }
                                        })}
                                    />
                                    {(errors?.aadhar) ? <FormErrorMessageSpan>{errors.aadhar.message}</FormErrorMessageSpan> : null}

                                </InputMintDiv>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} style={{ margin: '7px 0px' }}>
                                <p>Do you want to add nominee?</p>
                            </Col>
                            <Col xs={24}>
                                <div className="flex-row">
                                    <CustomRadio
                                        onChange={() => optInOutHandler(true)}
                                        name='doYouWantToAddNominee'
                                        label="Yes"
                                        checked={defaultOccupationValues?.optIn}
                                        disabled={profileView?.registeredWithBse === 3}
                                        radiobuttonRef={register()}
                                    />
                                    <CustomRadio
                                        onChange={() => optInOutHandler(false)}
                                        name='doYouWantToAddNominee'
                                        label="No"
                                        radiobuttonRef={register()}
                                        checked={!defaultOccupationValues?.optIn}
                                        disabled={profileView?.registeredWithBse === 3}
                                    />
                                </div>
                            </Col>
                        </Row><br />

                        {defaultOccupationValues?.optIn && <NomineeFieldArray {...formState} defaultOccupationValues={defaultOccupationValues} />}<br />

                        <Row>
                            <label>
                                <Checkbox
                                    name="fatcaCompliant"
                                    label={<span style={{ color: "black", lineHeight: "1.5" }} >I agree to the <a onClick={() => setShowFatcaDetails(true)} style={{ color: "#0268ed" }}>T&C</a> </span>}
                                    checked={fatcaCheckedStatus}
                                    onChange={(e: any) => {
                                        setFatcaCheckedStatus(e.target.checked);
                                        Mixpanel.track(getEventName("fatcaCompliant", "clicked", "checkout"), {
                                            agentCode: getAgentCode(),
                                            user: getUserDetails(),
                                            isBtoCFlow: isBtoCFlow(),
                                        });
                                    }}
                                    className="fatcaCompliance"
                                    checkboxRef={register}
                                    disabled={profileView?.registeredWithBse === 3}
                                />
                            </label>

                        </Row>
                        <p>Take a picture or upload an existing picture of your signature on a plain paper.</p>
                        <br />
                        <input
                            accept="image/*"
                            onChange={(e: any) => onChangePicture(e.target.files[0])}
                            type="file"
                            name="signatureURL"
                            id="signatureFile"
                            disabled={profileView?.registeredWithBse === 3}
                        />

                        {!signatureUploaded &&
                            <div style={{ marginBottom: "60px" }}>

                                <div
                                    style={{ marginLeft: "10px", float: "left" }}
                                    className={ profileView?.registeredWithBse === 3? "disabledlabelForFileInput" : "labelForFileInput"}
                                    onClick={() => { (document.getElementById("signatureFile") as HTMLInputElement).click() }} >
                                    <img src={uploadImage} alt=""></img>
                                    <p style={{ marginTop: "10px" }}>Upload File</p>
                                </div>
                                <br /><br />
                            </div>
                        }
                        {signatureUploaded &&
                            <div className={!isMobile ? "floatUpdateDiv" : ""}>
                                <img className="sinature-pic" alt="signature" height="200px" width={isMobile ? "100%" : "300"} src={signaturePicUrl} ></img>
                                <br />
                                <p className="updatePic" onClick={() => { (document.getElementById("signatureFile") as HTMLInputElement).click() }}>
                                    <img src={update} alt="" style={{ verticalAlign: "middle" }} ></img> &nbsp;
                                    <span style={{ lineHeight: "1.4" }}>Update picture</span>
                                </p>
                            </div>
                        }
                        {
                            signatureURLError && <FormErrorMessageSpan style={{ marginTop: "55px" }}>Please upload your signature.</FormErrorMessageSpan>
                        }
                        <div style={{ minWidth: "100%" }}>
                            <OccupationDetailsSubmitButton type="submit" isMobile={isMobile}>
                                {(profileView?.registeredWithBse !== 3) ? 'Get OTP' : 'Continue'}
                            </OccupationDetailsSubmitButton>
                        </div>
                    </form>
                </OccupationForm>
            </OccupationDetailsWhiteCard>
        </WhiteCardWrapper>
        {showFatcaDetails && <FatcaDetails handleFatcaDetails={handleFatca} />}
        {noFatcaError && <FatcaDetails handleFatcaDetails={handleFatca} fatcaError={true} />}

        {otpScreen && <OtpPopup onSuccessCallBack={otpSuccess} />}
    </div>);
};

export default OccupationDetails;

